import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "maintenance" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-[10%] right-[10%] top-[40%] flex animate-fade-up flex-col items-center animate-once" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "p-4 text-center text-4xl font-bold md:text-6xl" }, "Site under maintenance."),
  /*#__PURE__*/_createElementVNode("h3", { class: "p-4 text-center text-xl md:text-3xl" }, "We should be back up and running soon")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_background = _resolveComponent("background")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_background, { class: "z-0" }),
    _hoisted_2
  ]))
}